import { styled } from '@mui/material';
import CTAButton from '@components/CTAButton';

export const Wrapper = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px 30px 18px',
    borderRadius: 4,
    width: 575,
  },
  ({ theme }) => ({
    backgroundColor: theme.palette.novotalk.$backgroundColor,
  }),
);

export const Body = styled('div')({
  minWidth: 320,
  maxWidth: 320,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  marginBottom: 24,
});

export const Title = styled('div')({
  marginBottom: 7,
  width: '100%',
  textAlign: 'center',
});

export const Buttons = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
});

const BaseButton = styled(CTAButton)({
  width: 260,
  height: 52,
  borderRadius: 26,
  marginBottom: 12,
});

export const EndForAllButton = styled(BaseButton)({});

export const LeaveOnlyMeButton = styled(BaseButton)({});

export const CancelButton = styled(BaseButton)({
  marginBottom: 0,
});
